import { t } from '@lingui/core/macro';
import { Container } from '@mui/material';
import { Outlet, useMatchRoute } from '@tanstack/react-router';
import Logo from 'components/Logo';
import Page from 'components/Page';
import type { FC } from 'react';
import {
  ContentStyled,
  HeaderStyled,
  RootStyled,
  TitleContainerStyled,
  TitleStyled,
} from './styles';

const LoginContainer: FC = () => {
  const matchRoute = useMatchRoute();

  const getTitle = () => {
    if (matchRoute({ to: '/login/phone_number' })) return t`Espace Pharmacien`;
    if (matchRoute({ to: '/login/email' })) return t`Espace Partenaire`;

    return '';
  };

  return (
    <Page title="Login">
      <RootStyled>
        <HeaderStyled>
          <Logo />
          <TitleContainerStyled>
            <TitleStyled>{getTitle()}</TitleStyled>
          </TitleContainerStyled>
        </HeaderStyled>
        <Container maxWidth="sm">
          <ContentStyled>
            <Outlet />
          </ContentStyled>
        </Container>
      </RootStyled>
    </Page>
  );
};

export default LoginContainer;
